import { api } from "@/http/api-client"

export type TDeleteAccountParams = {
  organizationSlug: string
  accountId: string
}

export function deleteAccount(params: TDeleteAccountParams) {
  const searchParams = new URLSearchParams()
  searchParams.set("organizationSlug", params.organizationSlug)

  return api.delete(
    `/finances/accounts/${params.accountId}?${searchParams.toString()}`,
  )
}
